module.exports = __webpack_public_path__ + "static/media/remmend_header.e651e0aa.png";